export default "__VITE_ASSET__CokUVVg7__"